export default __webpack_public_path__ + "static/media/MeetingLobbyBlur.b48cb34a.PNG";